import { useLocation, useRoutes } from 'react-router-dom';
import routes from './routes';
import { Helmet } from 'react-helmet-async';
import ScrollToTop from './components/scrollToTop/ScrollToTop';
import AppContext from './contexts/Appcontext';
import { useEffect, useState } from 'react';
import axiosRequest from './services/axios/axiosRequest';
import Loading from './components/loading/Loading';
import DiscountBar from './components/discountBar/DiscountBar';


function App() {

  const router = useRoutes(routes);
  const { pathname } = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [siteInfos, setSiteInfos] = useState({});
  const [productsCategory, setProductsCategory] = useState([]);
  const [hasDiscount, setHasDiscount] = useState(false);

  useEffect(() => {
    const siteInfosController = new AbortController();
    const productsCategoryController = new AbortController();
    Promise.all([
      axiosRequest.get('/information/', { signal: siteInfosController.signal }),
      axiosRequest.get('/categories/', { signal: productsCategoryController.signal }),
    ])
      .then(([siteInfosRes, productsCategoryRes]) => {
        setSiteInfos(siteInfosRes.data);
        setProductsCategory(productsCategoryRes.data);
        setHasDiscount(siteInfosRes.data.has_discount);
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false));
    return () => {
      siteInfosController.abort();
      productsCategoryController.abort();
    }
  }, []);

  useEffect(() => window.scrollTo(0, 0), [pathname]);

  const appContextValues = {
    siteInfos,
    hasDiscount,
    setHasDiscount,
    productsCategory,
  }

  return (
    <AppContext.Provider value={appContextValues}>
      <Helmet>
        <title>نوآوران پژوه</title>
        <meta name="description" content="شرکت نوآوران پژوه وارد کننده تجهیزات و لوازم مصرفی پلاستیکی آزمایشکاهی و تحقیقاتی و دارویی، مواد شیمیایی، مولکولار و سلولار" />
      </Helmet>
      {
        isLoading ?
          <Loading />
          :
          <>
            {hasDiscount && pathname !== '/' && pathname !== '/search' && !router.props.match.params['*'] && <DiscountBar close={() => setHasDiscount(false)} />}
            {router}
            <ScrollToTop />
          </>
      }
    </AppContext.Provider >
  );
}

export default App;
